/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Kpi_Attributed_HintInputs */



/**
* | output |
* | --- |
* | "Referred, not managed" |
*
* @param {Partner_Admin_Kpi_Attributed_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_kpi_attributed_hint = /** @type {((inputs?: Partner_Admin_Kpi_Attributed_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Kpi_Attributed_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Empfohlen, nicht verwaltet")
	return /** @type {LocalizedString} */ ("Referred, not managed")
});